import { SITE_TITLE } from '@/constants/env';
import { fadeIn } from '@/constants/motions';
import { footerPrimaryMenu, footerSecondaryMenu, links } from '@/content';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import Link from 'next/link';

export default function FooterBlock({ footer }) {
  return (
    <motion.footer
      className="bg-primary-700 px-4 text-white"
      initial="hidden"
      transition={fadeIn.transition}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
    >
      <FooterMiddle
        footer={
          footer || {
            companies: { heading: '', links: [] },
            quickLinks: { heading: '', links: [] },
            contactInfo: { heading: '', infos: [] },
          }
        }
      />
      <FooterBottom
        footerBottom={(footer && footer.footerBottom) || { copyrightText: '', socialLinks: [] }}
      />
    </motion.footer>
  );
}

function FooterMiddle({ footer }) {
  return (
    <div className="container-screen py-12">
      <div className="flex flex-wrap gap-y-8">
        <LinksColumn heading="Quick Links" links={footer?.quickLinks || { links: [] }} />
        <LinksColumn heading="Companies" links={footer?.companies || { links: [] }} />
        <div className="w-full md:w-1/3">
          <h2 className="text-2xl font-medium">{footer?.contactInfo?.heading || ''}</h2>
          <div className="mt-6 flex flex-col gap-4">
            {/* <div className="flex gap-2">
              <Icon height="24" icon="fluent:call-24-filled" />
              <div className="flex flex-col">
                <span>Telephone</span>
                <span className="font-light text-white/80">+597-459070 / +1-7866971099</span>
              </div>
            </div>
            <div className="flex gap-2">
              <Icon height="24" icon="fluent:globe-location-24-filled" />
              <div className="flex flex-col">
                <span>Address</span>
                <span className="font-light text-white/80">
                  Plutostraat 108, Paramaribo, Suriname
                </span>
              </div>
            </div>
            <div className="flex gap-2">
              <Icon height="24" icon="fluent:mail-24-filled" />
              <div className="flex flex-col">
                <span>Email Address</span>
                <span className="font-light text-white/80">info@ceadnv.com</span>
              </div>
            </div> */}
            {(footer?.contactInfo?.infos || []).map(({ text, title, icon }, i) => (
              <div key={i} className="flex gap-2">
                <Icon height="24" icon={icon} />
                <div className="flex flex-col">
                  <span>{title}</span>
                  <span className="font-light text-white/80">{text}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function FooterBottom({ footerBottom }) {
  // const socialLinks = [
  //   {
  //     url: links.facebook,
  //     icon: <Icon height="28" icon="fa-brands:facebook-square" />,
  //   },
  //   {
  //     url: links.linkedIn,
  //     icon: <Icon height="28" icon="fa-brands:linkedin" />,
  //   },
  // ];

  return (
    <div className="container-screen border-t border-primary-600 py-8">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <p className="text-center sm:text-left">
          {/* Copyright &copy; {new Date().getFullYear()} {SITE_TITLE} All rights reserved. */}
          {footerBottom?.copyrightText || ''}
        </p>
        <div className="flex justify-center gap-4">
          {(footerBottom?.socialLinks || []).map(({ url, icon }, i) => (
            <a
              key={i}
              className="transition hover:opacity-80 focus-visible:outline-dashed focus-visible:outline-offset-4 focus-visible:outline-primary-200 "
              href={url}
              rel="noreferrer"
              target="_blank"
            >
              <Icon height="28" icon={icon} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

function LinksColumn(data) {
  return (
    <div className="w-full sm:w-1/2 md:w-1/3">
      <h2 className="text-2xl font-medium">{data.heading}</h2>
      <nav className="mt-6 flex flex-col items-start gap-2">
        {(data?.links?.links || []).map(({ url, text }, i) => (
          <Link key={i} href={url}>
            <a className="flex items-center gap-2 pr-2 font-light hover:underline hover:underline-offset-4 focus-visible:outline-dashed focus-visible:outline-primary-200">
              <Icon height="16" icon="fluent:chevron-right-12-filled" />
              {text}
            </a>
          </Link>
        ))}
      </nav>
    </div>
  );
}
